import { render, staticRenderFns } from "./external-api.md?vue&type=template&id=4bd5863e&"
import script from "./external-api.md?vue&type=script&lang=js&"
export * from "./external-api.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports